module.exports = __webpack_public_path__ + "img/alter-ego-hero_cn.34bc12f.png";